import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("chatbots.search_engine.title"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                _vm._v(_vm._s(_vm.$t("chatbots.search_engine.description"))),
              ]),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goCreatePage()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VRow,
        {
          class: {
            "flex-filter": _vm.size_screen == "sm" || _vm.size_screen == "xs",
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex-filter-order1", class: _vm.getClassTable },
            [
              _c(
                VCard,
                [
                  _c(VDataTable, {
                    staticClass: "table-inca",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.data,
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.actions",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onEditProject(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-edit"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onViewProject(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-view"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onRemoveProject(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-delete"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
            ],
            1
          ),
          _vm.filter_enabled
            ? _c(
                "div",
                {
                  staticClass: "col-md-3 col-sm-12 mb-3",
                  class: {
                    "pl-0": _vm.size_screen == "md" || _vm.size_screen == "lg",
                  },
                },
                [
                  _c(
                    VCard,
                    { staticClass: "filters-inca" },
                    [
                      _c(
                        VCardTitle,
                        {
                          staticClass: "pointer pb-0",
                          on: {
                            click: function ($event) {
                              _vm.collapse_filter = !_vm.collapse_filter
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                      ),
                      _c(
                        VCardText,
                        { staticClass: "pa-2 pt-0" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: _vm.$t(
                                        "chatbots.bots.metadata.name"
                                      ),
                                      placeholder: _vm.$t(
                                        "chatbots.bots.metadata.name"
                                      ),
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "name", $$v)
                                      },
                                      expression: "filters.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: _vm.$t(
                                        "chatbots.bots.metadata.description"
                                      ),
                                      placeholder: _vm.$t(
                                        "chatbots.bots.metadata.description"
                                      ),
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "filters.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                {
                                  staticClass: "text-right",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "default mr-1",
                                      attrs: { outlined: "" },
                                      on: { click: _vm.onLimpiar },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "primary ",
                                      on: { click: _vm.onSearch },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "dialogs-component",
        {
          ref: "DIALOG_CRUD_BOT",
          attrs: { title: "Search Engine", width: 850 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form_project", attrs: { id: "form_project" } },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("chatbots.search_engine.metadata.type")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              items: _vm.type_params,
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                              rules: _vm.rules.name,
                            },
                            model: {
                              value: _vm.item_selected.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.item_selected, "type", $$v)
                              },
                              expression: "item_selected.type",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("chatbots.search_engine.metadata.name")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                              rules: _vm.rules.name,
                            },
                            model: {
                              value: _vm.item_selected.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.item_selected, "description", $$v)
                              },
                              expression: "item_selected.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "chatbots.search_engine.metadata.description"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                              rules: _vm.rules.name,
                              rows: 2,
                            },
                            model: {
                              value: _vm.item_selected.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.item_selected, "description", $$v)
                              },
                              expression: "item_selected.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.view
                    ? _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "chatbots.search_engine.metadata.secret"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "4" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  filled: _vm.view,
                                  disabled: _vm.view,
                                  rules: _vm.rules.name,
                                },
                                model: {
                                  value: _vm.item_selected.secret,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item_selected, "secret", $$v)
                                  },
                                  expression: "item_selected.secret",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _vm.edit || _vm.view == false
                ? _c(
                    VBtn,
                    {
                      staticClass: "primary mr-1",
                      on: {
                        click: function ($event) {
                          _vm.edit ? _vm.onUpdateBot() : _vm.onSaveBot()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("btns.save")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c("dialog-confirmation-component", {
        ref: "DIALOG_REMOVE_BOT",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de eliminar el proyecto?",
        },
        on: { onConfirm: _vm.onConfirmRemoveProject },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }